module.exports = __webpack_public_path__ + "media/images/icons/icons_small/71_chat-25d869958d7bf621b9098e712c0a39c6.png";